import excelJS from 'exceljs'
import { save } from 'save-file'
import applyDefaultWorkbookView from '/utils/excel-workbook-view'
import moment from 'moment-timezone'
import _ from 'lodash'
import { getVisibleExportColumns } from '/utils/export-data'

const baseColumns = [
  {name:"Pass ID",item:"pass_id",width:100},
  {name:"Install URL",item:"public_id",width:200, format:"short_install_url"},
  {name:"Grouping ID",item:"grouping_id",width:100},
  {name:"Status",item:"expiry_date",width:100, format:"status"},
  {name:"Expiry Date",item:"expiry_date",width:50, format:"date"},
  {name:"Install Status",item:"install_status",width:50, format:"install_status"},
  {name:"First Installed",item:"first_installed_date",width:50, format:"utc_date"},
  {name:"Last Installed",item:"last_installed_date",width:50, format:"utc_date"},
  {name:"Last Uninstalled",item:"last_uninstalled_date",width:50, format:"utc_date"},
  {name:"Apple Installs",item:"apple_installs",width:50},
  {name:"Google Installs",item:"google_installs",width:50},
  {name:"Sync Required",item:"sync_required",width:50, format:"yes"},
  {name:"Created",item:"created_date",width:50, format:"utc_date"},
  {name:"Last Modified (Apple)",item:"apple_modified_date",width:50, format:"utc_date"},
  {name:"Last Modified (Google)",item:"google_modified_date",width:50, format:"utc_date"},
]

const passesListToExcel = async ({ template, fileName, data, visibleColumns }) => {

  const columns = getVisibleExportColumns(baseColumns.concat(getVariablesColumns(template)), visibleColumns)

  const workbook = new excelJS.Workbook()

  workbook.views = [
    {
      x: 0, y: 0, width: 3, height: 1000,
      firstSheet: 0, activeTab: 1, visibility: 'visible'
    }
  ]

  const font = { name: 'Courier', size: 12, bold: true }

  for (let key in data) {
    const dataItem = data[key]
    if (dataItem.length) {

      const passes_worksheet = workbook.addWorksheet(key)

      columns.map((col,idx) => passes_worksheet.getColumn(idx+1).width = col.width)

      const passes_row = passes_worksheet.getRow(1)

      columns.map((col,idx) => passes_row.getCell(idx+1).value = col.name)

      columns.map((col,idx) => passes_row.getCell(idx+1).font = font)

      dataItem.map((r, i) => {
        const row = passes_worksheet.getRow(i + 2)
      
        columns.map((col,idx) => 
          row.getCell(idx+1).value = col.format ? formatDataItem(r,col): _.get(r,col.item))
        columns.map((col,idx) => 
          row.getCell(idx+1).font = font)
      })
    }
  }


  applyDefaultWorkbookView(workbook)
  const buffer = await workbook.xlsx.writeBuffer()

  await save(buffer, fileName + '.xlsx')
}

export default passesListToExcel

const formatDataItem = (row,col) => {

  const value = row[col.item]

  switch (col.format) {
    case "date" : return value ? moment(value,"YYYYMMDDHHmmSS").format("YYYY-MM-DD HH:mm") : "-"
    case "utc_date" : return value ? moment.utc(value).tz('Europe/London').format("YYYY-MM-DD HH:mm") : "-"
    case "install_status" : return value === "in_use" ? "in use" : value === "dormant" ? "dormant" : "never used"
    case "short_install_url" : return value ? `https://api.smartix.uk/i/${value}` : "-"
    case "yes" : return value === 1 ? "yes" : ""
    case "status" : !value || moment.utc(value).isAfter(moment.utc()) ? "current" : "expired"
  }
}

const getVariablesColumns = template => {
  const scanner_data_columns = Object.keys(template.variables)

  return scanner_data_columns.map(name => {
    const item = "variables." + name
    return {name:name,item:item,width:100}
  })
}
